module.exports = __webpack_public_path__ + "static/img/bcg2.182755fd.jpg";